import React from 'react';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_DISH_CATEGORY } from 'helpers/roles';
import { withTranslation } from 'react-i18next';

import columnConfig from './columnConfig';
import DeleteCategoryAction from './components/DeleteCategoryAction';

const customActions = [
  { type: 'customComponent', component: DeleteCategoryAction },
];

const List = ({ classes, t, history }) => {
  const addCategory = () => history.push(`${window.location.pathname}/add`);

  return (
    <AdminTable title={t('dishCategories.list.title')}>
      {isGranted(ROLE_CREATE_DISH_CATEGORY) && (
        <FormControlButtons
          classes={classes}
          handleSubmit={addCategory}
          submitText={`${t('dishCategories.list.add')} +`}
        />
      )}
      <DataGrid
        actions={true}
        editPath={`${window.location.pathname}/edit`}
        remove={false}
        customActions={customActions}
        export={true}
        hideArchive={true}
        paginationTop={true}
        paginationBottom={false}
        defaultSorted={[{ id: 'position', desc: false }]}
        url="dish-categories"
        reportName="dishcategory"
        columns={columnConfig}
        role="DISH_CATEGORY"
      />
    </AdminTable>
  );
};

export default withTranslation()(withStyles(buttonsStyle)(List));
